module.exports = __webpack_public_path__ + "static/media/2-pin.66983518.svg";